import React  from 'react';

export default function Description(props) {
  const { project } = props;

  if (!_.trim(project.data.desiredOutcome)) {
    return null;
  }

  return (
    <div className="text-base text-gray-500 line-clamp-2">
      {project.data.desiredOutcome}
    </div>
  );
}
